
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.122 10.498l2.699 2.229 2.148-3.823 2.168 5.676a.092.092 0 00.075.059.09.09 0 00.085-.041l2.694-4.188h1.285a15.433 15.433 0 01-.91 2.9c-1.143 2.678-3.076 4.436-5.799 5.274-2.664-.928-4.547-2.688-5.65-5.277a14.589 14.589 0 01-.877-2.809h2.082zm4.445-8.088c1.26.725 2.42 1.287 3.48 1.69 1.061.402 2.168.683 3.327.843.21 1.305.258 2.588.142 3.848H15.11l-1.539 2.39-2.252-5.896a.089.089 0 00-.16-.012l-2.8 4.973L6.703 8.88H3.805a16.226 16.226 0 01.135-3.904 22.242 22.242 0 003.254-.971c1.162-.447 2.29-.98 3.373-1.594z","fill":"currentColor"}})])
          )
        }
      }
    